// extracted by mini-css-extract-plugin
export var bWarrper = "index-module--bWarrper--z8WcE";
export var banner = "index-module--banner--QcuDD";
export var bannerBtnsClass = "index-module--bannerBtnsClass--ZWDpn";
export var bannerDesc = "index-module--bannerDesc--mYhbk";
export var bannerTitle = "index-module--bannerTitle--M2HY8";
export var bannerWrapper = "index-module--bannerWrapper--Yxqer";
export var buttons = "index-module--buttons--z9onj";
export var customDetailClass = "index-module--customDetailClass--Wy17H";
export var featuresOverviewWrapper = "index-module--featuresOverviewWrapper--7puqv";
export var introduction1 = "index-module--introduction1--j0Djm";
export var itemContenWrapperClass = "index-module--itemContenWrapperClass--qI5Sb";
export var part6 = "index-module--part6--vGUgV";
export var partContent = "index-module--partContent--f+dJQ";
export var tabItemClass = "index-module--tabItemClass--vCCC7";
export var tabsClass = "index-module--tabsClass--zoWQg";
export var wWarrper = "index-module--wWarrper--YxHpN";